import React from 'react'
import Icon, { IconNames } from 'components/icons'
import theme from 'components/theme'
import { SwapFieldsContainer } from './styled'

const SwapFieldsButton = ({ onClick, size = 20, color = theme.colors.blue, rotateInTablet }) => (
  <SwapFieldsContainer onClick={() => onClick()} rotateInTablet={rotateInTablet}>
    <Icon name={IconNames.ArrowLeft} size={size} color={color} />
    <Icon name={IconNames.ArrowRight} size={size} color={color} />
  </SwapFieldsContainer>
)

export default SwapFieldsButton
